export default __webpack_public_path__ + "static/media/walle.828c6721.svg";